import { render, staticRenderFns } from "./mrc_ess_svgIcon.vue?vue&type=template&id=ffaffdca&scoped=true&"
import script from "./mrc_ess_svgIcon.vue?vue&type=script&lang=js&"
export * from "./mrc_ess_svgIcon.vue?vue&type=script&lang=js&"
import style0 from "./mrc_ess_svgIcon.vue?vue&type=style&index=0&id=ffaffdca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffaffdca",
  null
  
)

export default component.exports